/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  MISSING_INFO_WP_SUCCESS: {
    message: 'Work Permit Terminated successfully',
  },
  MISSING_INFO_WP_ERROR: {
    message: 'Failed to terminate work permit',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.missingInformation',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_MISSING_INFO_WP' },
      },
    },
    INITIATE_MISSING_INFO_WP: {
      invoke: {
        id: 'missingInformation',
        src: 'missingInformation',
        onDone: {
          target: 'MISSING_INFO_WP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'MISSING_INFO_WP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    MISSING_INFO_WP_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_MISSING_INFO_WP' },
      },
    },
    MISSING_INFO_WP_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_MISSING_INFO_WP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
